import { Observable, switchMap, tap } from 'rxjs';
import { inject } from '@angular/core';

import { CmsComponent } from '@spartacus/core';

import { ComponentService } from '../../services/component.service';
import { CmsModuleComponent } from '../../models/cms-module-component.model';
import { AbstractComponent } from './abstract-component.component';

export abstract class AbstractModuleComponent<T> extends AbstractComponent<T> {
  protected componentService = inject(ComponentService);

  protected module$: Observable<CmsModuleComponent>;

  constructor() {
    super();

    this.module$ = this.component$.pipe(
      tap((module) => this.onModuleInit(module)),
      switchMap((module) => (
        this.componentService.getLazyComponentData(module, 'components', this.mandatoryComponentFunction)
      ))
    );
  }

  mandatoryComponentFunction = (_cmp: CmsComponent) => true;

  onModuleInit(_module: CmsModuleComponent): void {
    /* allow-empty */
  }
}
